export const SSE_HEADER = {
  ROULETTE: {
    INITIALIZED_BET: "InitializedBet",
    FINISHED_BET: "FinishedBet",
    ROULETTE_TRANSFERRED: "RouletteTransferred",
    ROULETTE_SETTING_CHANGED: "RouletteSettingsUpdated",
  },

  SLOT: {
    INITIALIZED_BET: "InitializedBet",
    FINISHED_BET: "FinishedBet",
    ROULETTE_TRANSFERRED: "SlotMachineTransferred",
    ROULETTE_SETTING_CHANGED: "SlotMachineSettingsUpdated",
  },

  CRIME: {
    NEW_CRIME: "NewCrime",
  },

  JAIL: {
    BUY_OUT_PRISONER: "BuyOutPrisoner",
    BUST_OUT_PRISONER: "BustOutPrisoner",
  },

  SMUGGLE: {
    BOOZE_BUY: "BoozeBuy",
    BOOZE_SELL: "BoozeSell",

    NARCS_BUY: "NarcsBuy",
    NARCS_SELL: "NarcsSell",
  },

  CAR_NICK: {
    NEW_CAR_NICK: "NewCarNick",
  },

  KILL_SKILL: {
    NEW_KILL_SKILL: "TrainedSkill",
  },

  HELPER_BOT: {
    HELPER_BOT_STARTED: "HelperBotStarted",
    HELPER_BOT_ENDED: "HelperBotEnded",
  },

  XP_MARKET: {
    XP_LISTED: "XpListed",
    NEW_BID: "NewBid",
    ITEM_CANCELLED: "ItemCancelled",
    ITEM_PURCHASED: "ItemPurchased",
  },

  RACE: {
    RACE_CREATED: "RaceCreated",
    RACE_FINISHED: "RaceFinished",
    RACE_CANCELLED: "RaceCancelled",
  },

  PERK: {
    PERK_GENERATED: "PerkGenerated",
  },

  JACKPOT: {
    JACKPOT_ENTERED_POT: "EnteredPot",
    JACKPOT_CALCULATE_WINNER: "CalculateWinner",
  },

  SHOP: {
    SHOP_ITEM_BUY: "ShopItemBuy",
    ITEM_RESTOCKED: "ItemRestocked",
  },

  MYSTERY_BOX: {
    MYSTERY_BOX_OPENED: "MysteryBoxClaimed",
  },

  CRATE: {
    CRATE_OPENED: "ItemGenerated",
  }
};
